import { YStack } from 'tamagui';

export default YStack;
